export enum Cookie {
  CookieName = "ic_authenticationToken",
  CookieExpiry = "ic_authenticationToken",
  CookieDomain = "investingchannel.com",
  // CookieDomain = "emailadserver.ui.com",
  // CookieDomain = "localhost",
  // PrcUrl = "//localhost:4300/",
  PrcUrl = "//stgprc.investingchannel.com",
  // PrcUrl = "//stgprcui.investingchannel.com",
  // PrcUrl = "//prc.investingchannel.com",
  AppLocation = "/authentication/#/",
}
